<template>
  <div class="wt2-sg wt-text-overlay-field wt-position-grid">
    <div v-if="hasLabel" class="-title wt2-text-n wt2-color-normal">
      {{ field.label }}
      <slot name="tooltip"></slot>
    </div>
    <div class="wt-position">
      <div class="-selection-wrapper">
        <div
          v-for="(p, i) in positions"
          @click="select(p)"
          :key="i"
          :class="{
            '-selection-item': true,
            active: p.value === selectedItemValue,
            disable: !p.enabled,
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

const POSITIONS_ENUM = {
  0: 'TL',
  1: 'T',
  2: 'TR',
  3: 'L',
  4: 'C',
  5: 'R',
  6: 'BL',
  7: 'B',
  8: 'BR',
};

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['label', 'name'], (prop) =>
          _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      selectedItemValue: null,
      positions: [],
    };
  },

  created() {
    this.selectedItemValue =
      this.field.value || POSITIONS_ENUM[Number(this.field.defaultValue)];
    this.positions = [];
    this.field.options.forEach((value, key) => {
      this.positions.push({
        enabled: value === 'true' || value === true,
        value: POSITIONS_ENUM[key],
      });
    });
    this.emitChange({ newValue: this.selectedItemValue, makeDirty: false });
    this.$watch('selectedItemValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },
  computed: {
    hasLabel() {
      return !_.isEmpty(this.field.label);
    },
  },
  methods: {
    select(item) {
      if (!item.enabled) {
        return;
      }
      this.selectedItemValue = item.value;
    },
  },
};
</script>
